import {
  AccessActions,
  CLEAR_ACCESSES,
  RECEIVE_ACCESSES,
  RECEIVE_BATCH_CHECK,
  RESET_ACCESS,
  SET_ACCESS,
  SET_ACCESS_ACL,
} from "common/reducers/access.actions";
import { accessFromJSON, AccessRecord } from "common/records/Access";
import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { receive, reset } from "common/reducers/Utils";
import { OrgActions } from "common/reducers/org.actions";
import { reducer as orgReducer } from "common/reducers/org.reducer";
import { isDirty } from "common/helpers/Record";

export const AccessStateRecord = Record({
  byId: Map<number, AccessRecord>(),
  lastSavedById: Map<number, AccessRecord>(),
  // Map<orgId, Map<userId, accessId>>
  batchCheckByOrgUserId: Map<number, Map<number, number | null>>(),
});

export const initialState = AccessStateRecord();

export type AccessState = typeof initialState;

export const model = "accesses";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }
  switch (action.type) {
    case SET_ACCESS: {
      const { access, id } = action.payload;
      const immutableAccess = accessFromJSON(access);

      if (access.org) {
        state = orgReducer(state, OrgActions.receiveOrgOverviews([access.org]));
      }

      const current = state.getIn([model, "byId", id]);
      const lastSaved = state.getIn([model, "lastSavedById", id]);

      if (isDirty(current, lastSaved) && !action.payload.overrideDirty) {
        return state;
      }

      return receive(state, model, immutableAccess) as RootState;
    }
    case RESET_ACCESS: {
      const { id } = action.payload;
      return reset(state, model, id) as RootState;
    }

    case SET_ACCESS_ACL: {
      const { acl, id } = action.payload;
      return state.updateIn([model, "byId", id], accessFromJSON({ id }), (ar: AccessRecord) => ar.set("acl", acl));
    }

    case RECEIVE_ACCESSES:
      action.payload.accesses.forEach((access) => {
        state = reducer(state, AccessActions.setAccess(access.id, access, action.payload.overrideDirty));
      });
      return state;

    case CLEAR_ACCESSES:
      return state.set(model, initialState);

    case RECEIVE_BATCH_CHECK: {
      const { orgId, results } = action.payload;
      results.forEach((r) => {
        state = state.setIn([model, "batchCheckByOrgUserId", orgId, r.user_id], r.access_id);
      });
      return state;
    }

    default:
      return state;
  }
};
